import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import { Card, CardContent } from '@mui/material';
import { forgotPasswordRequest } from '../../../redux/ducks/UserDucks';

import { ForgotPasswordForm } from '../../input/ForgotPasswordForm/ForgotPasswordForm';
import { Footer } from '../../layout/Footer';
import { useStyles } from './ForgotPasswordPage.styles';
import useIsDesktop from '../../../hooks/useIsDesktop/useIsDesktop';

export function ForgotPasswordPage() {
  const isDesktop = useIsDesktop();
  const classes = useStyles({ isDesktop });
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.user.isLoading);
  const resetRequested = useSelector((state) => state.user.resetRequested);

  const onSubmit = (data) => {
    // Tell the auth service to point the email link back at this portal.
    // Using window.location.origin (instead of a hardcoded host) means
    // production, staging and preview each send their own host without env
    // wiring. The auth service must have each host whitelisted in
    // TRUSTED_ORIGINS or it silently falls back to the default — coordinate
    // with the Auth Hub team before promoting a new environment.
    const redirectUrl = `${window.location.origin}/reset-password`;
    dispatch(forgotPasswordRequest({ ...data, redirectUrl }));
  };

  return (
    <>
      <Container
        component="main"
        maxWidth="xs"
        className={classes.rootcontainer}
      >
        <Card className={classes.card} variant="outlined">
          <CardContent className={classes.cardContent}>
            <Grid
              container
              direction="column"
              justifyContent="center"
              alignItems="stretch"
            >
              <Grid item xs={12}>
                <Grid container>
                  <Grid item lg>
                    <ForgotPasswordForm
                      onSubmit={onSubmit}
                      isLoading={isLoading}
                      resetRequested={resetRequested}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Container>
      <Footer />
    </>
  );
}
